import { render, staticRenderFns } from "./GeneralDataCard.vue?vue&type=template&id=6d028450&scoped=true&"
import script from "./GeneralDataCard.vue?vue&type=script&lang=js&"
export * from "./GeneralDataCard.vue?vue&type=script&lang=js&"
import style0 from "./GeneralDataCard.vue?vue&type=style&index=0&id=6d028450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d028450",
  null
  
)

export default component.exports